import { getYear } from 'date-fns'

import { useDateLimits } from '../../../hooks'
import { MonthYearSelect } from '../MonthYearSelect'

import { getYearSelectOption, getYearSelectOptions } from './YearSelect.utils'

import * as styles from './YearSelect.module.css'

function YearSelect({
  className = styles.YearSelect,
  maxValue,
  minValue,
  value,
  onChange,
  ...selectProps
}) {
  const limits = useDateLimits()
  const minYear = minValue ?? getYear(limits.minDate)
  const maxYear = maxValue ?? getYear(limits.maxDate)

  const selectOptions = getYearSelectOptions(minYear, maxYear)

  const selectValue =
    selectOptions.find(option => option.value === value) ??
    (value == null ? null : getYearSelectOption(value))

  function handleSelectItem({ value }) {
    onChange?.(value)
  }

  return (
    <MonthYearSelect
      {...selectProps}
      className={className}
      options={selectOptions}
      value={selectValue}
      onSelectItem={handleSelectItem}
    />
  )
}

export default YearSelect
